import { get } from 'lodash';

export const getHeaderDisplay = (state) =>
  get(state, 'GlobalUIState.headerDisplay');

export const getSidebarDisplay = (state) =>
  get(state, 'GlobalUIState.sidebarDisplay');

export const getKeyboardDisplay = (state) =>
  get(state, 'GlobalUIState.keyboardDisplay');

export const getKeyboardActive = (state) =>
  get(state, 'GlobalUIState.keyboardActive');

export const getFullscreen = (state) => get(state, 'GlobalUIState.fullscreen');

export const getIsSidebarMessagesPanelActive = (state) =>
  get(state, 'GlobalUIState.isSidebarMessagesPanelActive');

export const getSidebarMessages = (state) =>
  get(state, 'GlobalUIState.sidebarMessages');

export const getNotifications = (state) =>
  get(state, 'GlobalUIState.notifications');



// WEBPACK FOOTER //
// ./src/common/UI/state/selectors.js